// ReviewsTab.js
import React, { useState, useEffect } from "react";
import { collection, getDocs, updateDoc, doc, deleteField } from "firebase/firestore";
import { toast } from "react-toastify";

const ReviewsTab = ({ db, id, collectionPath }) => {
  const [reviews, setReviews] = useState([]);

  useEffect(() => {
    const fetchReviews = async () => {
      if (id) {
        const reviewsCollectionRef = collection(db, `${collectionPath}Products/ProductsList/DataBase/${id}/Reviews`);
        const reviewsSnapshot = await getDocs(reviewsCollectionRef);
        const reviewsArray = await Promise.all(
          reviewsSnapshot.docs.map(async (docSnap) => {
            const reviewData = docSnap.data();
            const reportsCollectionRef = collection(db, `${collectionPath}Products/ProductsList/DataBase/${id}/Reviews/${docSnap.id}/Reports`);
            const reportsSnapshot = await getDocs(reportsCollectionRef);
            const reportsArray = reportsSnapshot.docs.map((reportDoc) => ({
              reportId: reportDoc.id,
              ...reportDoc.data(),
            }));
            return { id: docSnap.id, ...reviewData, reports: reportsArray };
          })
        );
        setReviews(reviewsArray);
      }
    };
    fetchReviews();
  }, [db, id, collectionPath]);

  const handleIgnoreReport = async (reviewId, reportId) => {
    try {
      const reportDocRef = doc(db, `${collectionPath}Products/ProductsList/DataBase/${id}/Reviews/${reviewId}/Reports`, reportId);
      await updateDoc(reportDocRef, {
        checked: true,
        report_remove_review: deleteField(),
        report_remove_review_date: deleteField(),
      });
      toast.success("Report ignored successfully");
    } catch (error) {
      console.error("Error ignoring report:", error);
      toast.error("Error ignoring report");
    }
  };

  const handleRemoveReview = async (reviewId, reportId) => {
    try {
      const reviewDocRef = doc(db, `${collectionPath}Products/ProductsList/DataBase/${id}/Reviews`, reviewId);
      const reportDocRef = doc(db, `${collectionPath}Products/ProductsList/DataBase/${id}/Reviews/${reviewId}/Reports`, reportId);
      const removalDate = new Date();
      await updateDoc(reportDocRef, {
        checked: true,
        report_remove_review: true,
        report_remove_review_date: removalDate,
      });
      await updateDoc(reviewDocRef, {
        remove_review: true,
        remove_review_date: removalDate,
      });
      toast.success("Review removed successfully");
    } catch (error) {
      console.error("Error removing review:", error);
      toast.error("Error removing review");
    }
  };

  return (
    <div style={{ ...styles.container, ...styles.form }}>
      <h2>Product Reviews</h2>
      {reviews.map((review) => (
        <div key={review.id} style={styles.reviewItem}>
          <p>Rating: {review.rating}</p>
          <p>Comment: {review.comment}</p>
          {review.reports && review.reports.length > 0 ? (
            <div>
              <h3>Reports ({review.reports.length}):</h3>
              {review.reports.map((report, index) => (
                <div key={index} style={styles.reportItem}>
                  <div>
                    <p>
                      Report as <b>{report.reason}</b> on {new Date(report.timestamp.seconds * 1000).toLocaleDateString()}
                    </p>
                  </div>
                  <div style={styles.reportActions}>
                    <div onClick={() => handleIgnoreReport(review.id, report.reportId)} style={styles.actionText}>
                      Ignore
                    </div>
                    <div onClick={() => handleRemoveReview(review.id, report.reportId)} style={styles.actionText}>
                      Remove Review
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <p>No reports for this review.</p>
          )}
        </div>
      ))}
    </div>
  );
};

const styles = {
  container: {
    padding: 20,
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: 10,
    width: 300,
    border: "1px solid #ccc",
    flex: 1,
    borderRadius: 5,
    backgroundColor: "#f9f9f9",
    width: "100%",
  },
  reviewItem: {
    border: "1px solid #ccc",
    padding: 10,
    marginBottom: 10,
    backgroundColor: "#fff",
  },
  reportItem: {
    border: "1px solid #eee",
    padding: 5,
    marginBottom: 5,
    display: "flex",
    justifyContent: "space-between",
  },
  reportActions: {
    display: "flex",
    gap: 10,
  },
  actionText: {
    textDecoration: "underline",
    cursor: "pointer",
  },
};

export default ReviewsTab;
